import { render, staticRenderFns } from "./integration-logs.vue?vue&type=template&id=3de63968&scoped=true&"
import script from "./integration-logs.vue?vue&type=script&lang=js&"
export * from "./integration-logs.vue?vue&type=script&lang=js&"
import style0 from "./integration-logs.vue?vue&type=style&index=0&id=3de63968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de63968",
  null
  
)

export default component.exports